export const HOME = "/";
export const CHAT = "/chat";


